import cn from 'classnames'
import { FC, useCallback, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { FormNumberInput, useGetFormDataField } from 'cng-common/features/form'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../translations'

import { tooltipMessage } from './configs'

import styles from './RetailerStoresEditMode.module.scss'

interface IRetailerStoresEditModeProps {
  storesTotal: Nullable<number>
  storesPSHW: Nullable<number>
  storesPRHW: Nullable<number>
}

export const RetailerStoresEditMode: FC<IRetailerStoresEditModeProps> = ({
  storesTotal,
  storesPSHW,
  storesPRHW,
}) => {
  const [formStoresTotal] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.storesTotal
  )

  const shouldShowCompletenessWarning = useCallback((currentValue: Nullable<number>) => {
    return currentValue === null
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const formStoresTotalTooltipCondition = useMemo(
    () => shouldShowCompletenessWarning(formStoresTotal) && !formStoresTotal,
    [formStoresTotal, shouldShowCompletenessWarning]
  )

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!formStoresTotalTooltipCondition} tipContent={tooltipRender}>
            <FormNumberInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.storesTotal}
              label={TRANSLATION_KEYS.storesTotalLabel}
              defaultValue={storesTotal}
              className={cn({ [styles.warning]: formStoresTotalTooltipCondition })}
            />
          </Tooltip>
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.storesPSHW}
            label={TRANSLATION_KEYS.storesPSHWLabel}
            defaultValue={storesPSHW}
          />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.storesPRHW}
            label={TRANSLATION_KEYS.storesPRHWLabel}
            defaultValue={storesPRHW}
          />
        </div>
      </div>
    </div>
  )
}
